import React, { createContext, useState, useEffect, useContext } from "react";
import { getFirebaseToken, isSupport } from "../firebase.js";
import { guardarDispositivoPersona } from "@conductor/services/dispositivo_persona.js";
import { useAuth } from "@conductor/context/AuthContext.jsx";
import firebaseConfig from "@shared/config/integrations/firebase.config.js";

const { MOBILE_INTERFACE } = firebaseConfig.MOBILE

const FirebaseContext = createContext(null);


export function FirebaseProvider({ children }) {
    const [firebaseToken, setFirebaseToken] = useState(null);
    const { userData } = useAuth()

    useEffect(() => {
        if (!userData) return;
        if (isSupport) {
            getFirebaseToken()
                .then(async (firebaseToken) => {
                    setFirebaseToken(firebaseToken);
                })
                .catch((err) => {
                    setFirebaseToken(null);
                    console.error("An error occured while retrieving firebase token", err)
                    throw new Error(err);
                }
                );
        } else {
            tokenNewPushNotification();
        }

        function tokenNewPushNotification() {
            if (/iPhone|iPad/i.test(navigator.userAgent)) {
                window.webkit.messageHandlers.JphIOS.postMessage({
                    "action": "tigerTokenNewPushNotification",
                    "params": {}
                });
            } else if (/Android/i.test(navigator.userAgent)) {
                if (typeof window[MOBILE_INTERFACE] !== 'undefined') {
                    window[MOBILE_INTERFACE].tigerTokenNewPushNotification();
                } else {
                    console.log("Está intentando acceder desde un navegador web móvil?");
                }

            }
        }

    }, [userData]);

    useEffect(() => {
        window.tigerGetTokenNewPN = tigerGetTokenNewPN;
        function tigerGetTokenNewPN(token) {
            setFirebaseToken(token);
        }
    })


    useEffect(() => {
        if (userData && firebaseToken !== null) {
            guardarDispositivoPersona(firebaseToken, userData).then().catch(error => {
                console.error(error);
            })
        }
        // if (!userData) {
        //     eliminarDispositivoPersona({ firebaseToken }).then().catch(error => {
        //         console.error(error);
        //     })
        // }
    }, [userData, firebaseToken])

    return <FirebaseContext.Provider value={{
        firebaseToken
    }}>{children}</FirebaseContext.Provider>

}

export const useFirebase = () => {
    return useContext(FirebaseContext);
}